import { useContext } from 'react';

import { Context } from '../context';

const useCrmAction = () => useContext(Context);

export default useCrmAction;
